import { render } from "./Check.vue?vue&type=template&id=b46184a4"
const script = {}

import exportComponent from "D:\\aj项目\\code\\清洁能源\\氢能会议系统\\chic-conference\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__